import React from 'react';
import { biometricSignals } from '../data/biometricSignals';
export const BiometricsSection: React.FC = () => {
  return <section id="biometrics" aria-labelledby="biometrics-heading" className="section-y bg-white" data-id="element-17" data-mp="2ua6dstaqqma4">
      <div className="section-container" data-id="element-18" data-mp="381kz56s4ezkc">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.2fr_1fr] lg:gap-16" data-id="element-19" data-mp="3391l68piu2f0">
          <div data-id="element-20" data-mp="3hxy2yxhdqtst">
            <span className="eyebrow" data-id="element-21" data-mp="3hxo8awle3ygs">In development</span>
            <h2 id="biometrics-heading" className="section-heading mt-4 max-w-[18ch]" data-id="element-22" data-mp="3i0af2u0gi9xy">
              Your body adds context to your story.
            </h2>
            <p className="section-lead mt-5" data-id="element-23" data-mp="3qxumylstr4hj">
              We’re working on bringing biometric information into Re:Joy,
              including heart rate, sleep, and activity. The aim is to help you
              and your therapist explore patterns alongside what you share and
              experience.
            </p>
            <p className="mt-4 max-w-[38rem] leading-relaxed text-deep-juniper" data-id="element-24" data-mp="1slchrjlohb13">
              These signals would add context to conversations about care,
              rather than define how you should feel.
            </p>
          </div>
          <div className="flex justify-center lg:justify-end" data-id="element-25" data-mp="17aeeajg2vcik">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wvcaqxDKyp9WjZpo3GnZAm/connections_paths_light.svg" alt="Two human figures drawn with dotted connection paths, representing body signals and lived experience together" className="h-auto w-full max-w-[280px] object-contain md:max-w-[360px]" data-id="element-26" data-mp="178tlay9ew1mt" />
          </div>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-6 md:mt-16 md:grid-cols-3" data-id="element-27" data-mp="1pzb9qqn7ob2d">
          {biometricSignals.map(signal => <li key={signal.title} className="card" data-id="element-28" data-mp="3rsr3vxiic823">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white" data-id="element-29" data-mp="3rubwvip6bixu">
                <img src={signal.icon} alt="" aria-hidden="true" className="h-6 w-6" data-id="element-30" data-mp="mznvqyg2bt0" />
              </div>
              <h3 className="mt-4 text-xl" data-id="element-31" data-mp="3orftsx7p55h0">{signal.title}</h3>
              <p className="mt-2 leading-relaxed text-plum-gray" data-id="element-32" data-mp="3kqceqcxh3dgu">
                {signal.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
};